import React from 'react';
import { Check, Star } from 'lucide-react';
import { motion } from 'framer-motion';
interface ComboCardProps {
  title: string;
  price: string;
  features: string[];
  description: string;
  isRecommended?: boolean;
  isPremium?: boolean;
  onBuy: () => void;
  image?: string;
}
export function ComboCard({
  title,
  price,
  features,
  description,
  isRecommended,
  isPremium,
  onBuy,
  image
}: ComboCardProps) {
  return <motion.div whileHover={{
    y: -5
  }} className={`relative flex flex-col h-full rounded-xl overflow-hidden ${isRecommended ? 'border-2 border-yellow-400 bg-gray-900 shadow-[0_0_30px_rgba(253,185,19,0.3)] transform scale-105 z-10' : isPremium ? 'border border-gray-700 bg-gray-900/80' : 'border border-gray-800 bg-black'}`} data-id="element-2">
      {isRecommended && <div className="bg-yellow-400 text-black text-center py-1 font-bold text-sm uppercase tracking-wider" data-id="element-3">
          Más Vendido
        </div>}

      {image && <div className="h-64 overflow-hidden relative bg-gray-900 flex items-center justify-center" data-id="element-4">
          <img src={image} alt={title} className="w-full h-full object-contain" data-id="element-5" />
        </div>}

      <div className="p-6 flex-1 flex flex-col" data-id="element-6">
        <h3 className={`text-xl font-bold mb-2 ${isRecommended ? 'text-yellow-400' : 'text-white'}`} data-id="element-7">
          {title}
        </h3>

        <div className="mb-4" data-id="element-8">
          <span className="text-3xl font-bold text-white" data-id="element-9">${price}</span>
        </div>

        <p className="text-gray-400 text-sm mb-6 min-h-[40px]" data-id="element-10">{description}</p>

        <div className="space-y-3 mb-8 flex-1" data-id="element-11">
          {features.map((feature, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-12">
              <div className={`mt-0.5 p-0.5 rounded-full ${isRecommended ? 'bg-yellow-400/20' : 'bg-gray-800'}`} data-id="element-13">
                <Check className={`w-3 h-3 ${isRecommended ? 'text-yellow-400' : 'text-gray-400'}`} data-id="element-14" />
              </div>
              <span className="text-gray-300 text-sm" data-id="element-15">{feature}</span>
            </div>)}
        </div>

        <button onClick={onBuy} className={`w-full py-3 px-4 rounded-lg font-bold text-lg transition-all duration-200 uppercase tracking-wide ${isRecommended ? 'bg-yellow-400 text-black hover:bg-yellow-300 shadow-lg shadow-yellow-400/20' : 'bg-white text-black hover:bg-gray-200'}`} data-id="element-16">
          Comprar Ahora
        </button>
      </div>
    </motion.div>;
}